<template lang="pug">
#wrap_sub
  .sub_left
  .sub_right
    .content_title
    .content_desc
      #mb_login.mbskin
        .loginForm(v-if="!secAuth")
          fieldset#login_fs
            input#login_id.frm_input.required(type='text' v-model='userinfo.id' required size='20' maxLength='20' placeholder='아이디')
            input.frm_input.required#login_pw(type='password' v-model='userinfo.password' required size='20' maxLength='20' placeholder='비밀번호')
            button.btn_submit(@click='login()') 로그인
        .sec_login(v-if="secAuth")
          .auth
            input#login_auth.frm_input.required(type='text' v-model='authNum' required size='6' maxLength='6' placeholder='인증번호' :readonly='!reSend')
            h3(v-if="reSend") {{resTimeData}}
        .sec_auth(v-if="secAuth")
          button.btn_submit(@click='sendMsg()' v-if="!reSend") 인증번호 받기
          button.btn_submit.fir_btn(@click='reSendMsg()' v-if="reSend") 재전송하기
          button.btn_submit.sec_btn(@click='secLogin()' v-if="reSend") 확인
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      tokenValue: false,
      userinfo: {
        id: '',
        password: '',
      },
      authNum: '',
      timeCounter: 180, //3분 180
      resTimeData: '',
      secAuth: false,
      reSend: false,
      reSendNum: 0,
    };
  },
  computed: {},
  methods: {
    ...mapActions(['saveToken', 'userAccToken', 'userAccTokenExp']),
    login() {
      const $_self = this;
      if (this.userinfo.id == '') {
        alert('아이디를 입력해주세요.');
        return;
      } else if (this.userinfo.password == '') {
        alert('비밀번호를 입력해주세요.');
        return;
      }
      this.$_login({
        id: this.userinfo.id,
        password: this.userinfo.password,
      }).then(res => {
        if (res.status == 204) {
          alert('아이디 또는 비밀번호가 잘못되었습니다.');
        } else if (res.status == 200) {
          this.passLogin();
        } else {
          alert('관리자에게 문의해주세요.');
        }
      });
    },
    async sendMsg() {
      // NOTE: 텔레그램 메시지 전송
      this.start();
      alert('인증번호가 전송되었습니다.');
      this.reSend = true;
      await this.$_axios('GET', 'admin/auth/message').then(res => {
        if (res.status === 200) {
          this.reSend = true;
        } else {
          alert('관리자에게 문의해주세요.');
        }
      });
    },
    reSendMsg() {
      const $_self = this;
      if (this.reSendNum > 2) {
        alert('재전송 최대 횟수를 초과하였습니다. 다시 로그인해주세요.');
        clearInterval(this.polling);
        this.userinfo.id = '';
        this.userinfo.password = '';
        this.authNum = '';
        this.secAuth = false;
        this.reSend = false;
        this.timeCounter = 180;
        this.reSendNum = 0;
      } else {
        this.$_axios('GET', 'admin/auth/message').then(res => {
          if (res.status === 200) {
            $_self.reSendNum++;
            $_self.smsReset();
            $_self.start();
            alert('인증번호가 재전송되었습니다.');
          } else {
            alert('관리자에게 문의해주세요.');
          }
        });
      }
    },
    secLogin() {
      const $_self = this;
      this.$_axios('GET', 'admin/auth/check', { num: this.authNum })
        .then(this.saveToken)
        .then(res => {
          if (res.status == 200) {
            $_self.$_goTo({ name: 'home' });
            clearInterval(this.polling);
          } else {
            alert('관리자에게 문의해주세요.');
          }
        })
        .catch(err => {
          let statusCode = err.request.status;
          if (statusCode == 705) {
            this.timeStop();
          } else if (statusCode == 706) {
            alert('인증번호가 일치하지 않습니다.');
          }
        });
    },

    passLogin() {
      const $_self = this;
      this.$_axios('GET', 'admin/auth/pass')
        .then(this.saveToken)
        .then(res => {
          if (res.status == 200) {
            $_self.$_goTo({ name: 'home' });
          } else {
            alert('관리자에게 문의해주세요.');
          }
        })
    },
    start() {
      this.polling = setInterval(() => {
        this.timeCounter--; //1씩 감소
        this.resTimeData = this.preTime();
        if (this.timeCounter <= 0) this.timeStop();
      }, 1000);
    },
    preTime() {
      // 시간 형식으로 변환
      let time = this.timeCounter / 60;
      let minutes = parseInt(time);
      let seconds = Math.round((time - minutes) * 60);
      return this.pad(minutes, 2) + ':' + this.pad(seconds, 2);
    },
    pad(n, width) {
      // 2자리수
      n = n + '';
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join('0') + n;
    },
    timeStop() {
      clearInterval(this.polling);
      alert('유효 시간이 만료되었습니다. 다시 로그인 해주세요.');
      this.userinfo.id = '';
      this.userinfo.password = '';
      this.authNum = '';
      this.secAuth = false;
      this.reSend = false;
      this.timeCounter = 180;
    },
    smsReset() {
      clearInterval(this.polling);
      this.timeCounter = 180;
    },
  },
  mounted() {
    if (this.userAccTokenExp) {
      let $_rS = (+new Date(this.userAccTokenExp) - +new Date()) / 1000;
      if ($_rS > 0) {
        this.tokenValue = true;
      } else {
        this.tokenValue = false;
      }
    } else {
      this.tokenValue = false;
    }
    if (this.userAccToken && this.tokenValue) {
      this.$_goTo({ name: 'home' });
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
    this.timeCounter = 180;
  },
};
</script>

<style scoped>
.auth {
  border: 1px solid #d0d3db;
}
.auth h3 {
  margin-right: 12px;
}
#login_auth {
  border: none;
  border-right: 0px;
  border-top: 0px;
}
.sec_login {
  width: 400px;
  height: 45px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  /* background-color: #dadada40; */
  border-radius: 7px;

  margin-bottom: 10px;
}
.auth,
.sec_auth {
  width: 400px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
#mb_login .sec_auth .fir_btn {
  width: 400px;
  margin-right: 5px;
}
#mb_login .sec_auth .sec_btn {
  width: 400px;
  margin-left: 5px;
}
.auth p {
  font-weight: bold;
  font-family: 'Noto Sans';
  font-size: 1.2em;
  padding-left: 15px;
  padding-right: 15px;
}
.auth h3 {
  padding-left: 10 px;
}
.auth a {
  padding-left: 15px;
  padding-right: 15px;
}
#login_auth {
  width: 390px;
  margin-right: 10px;
  /* text-align: center; */
}
#login_fs {
  padding: 0 50px;
}
@media (max-width: 768px) {
  #register_form {
    padding: 0px;
  }
  #login_fs {
    padding: 0 2%;
  }
  .register_tb_w table th {
    padding: 5px !important;
    letter-spacing: -1px;
  }
  #fregister .fregister_agree {
    position: relative;
    border-top: 1px solid #ddd;
  }
}

#mb_login #login_fs .frm_input {
  font-family: 'Noto Sans Korean';
  margin: 0 0 10px;
}
#mb_login #login_fs .btn_submit {
  margin: 0 0 20px;
}
#mb_login #login_info {
  max-width: 400px;
  background: #f8f8f8;
  padding: 25px 10px;
  border: 1px solid #e8e8e8;
  margin: 20px auto 0;
}
#mb_login #login_info:after {
  display: block;
  visibility: hidden;
  clear: both;
  content: '';
}
#mb_login #login_info h2 {
  position: absolute;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
}
#mb_login #login_info a {
  display: inline-block;
  width: 50%;
  /* float: left; */
}
#login_password_lost {
  border-right: 1px solid #ddd;
}

#mb_login_notmb {
  margin: 30px auto;
  padding: 20px 30px;
}
#mb_login_notmb h2 {
  font-size: 1.25em;
  margin: 20px 0 10px;
}
#guest_privacy {
  border: 1px solid #ccc;
  text-align: left;
  line-height: 1.6em;
  color: #666;
  background: #fafafa;
  padding: 10px;
  height: 150px;
  margin: 10px 0;
  overflow-y: auto;
}
#mb_login_notmb .btn_submit {
  display: block;
  text-align: center;
  line-height: 45px;
}

#mb_login_od_wr {
  margin: 30px auto;
  padding: 20px 30px;
}
#mb_login_od_wr h2 {
  font-size: 20px;
  margin: 20px 0 10px;
  color: #000;
}
#mb_login_od_wr .frm_input {
  margin: 10px 0 0;
}
#mb_login_od_wr p {
  background: #f3f3f3;
  margin: 20px 0 0;
  padding: 15px 20px;
  line-height: 1.5em;
}
/* 기본박스 */
.mbskin {
  position: relative;
  margin: 100px auto 0;
  max-width: 500px;
  background: #fff;
  text-align: center;
}
.mbskin .frm_input {
  width: 100%;
}
.mbskin .btn_submit {
  width: 100%;
  margin: 10px 0 0;
  height: 45px;
  font-weight: bold;
  font-family: 'Noto Sans';
  font-size: 1.25em;
}
.mbskin h1 {
  margin: 20px 0 30px;
  font-size: 2em;
}

.btn_submit {
  background: #333 !important;
  text-align: center;
}
.btn_submit:hover {
  background: #f7941e !important;
}
</style>
